import React from "react";
import { motion } from "framer-motion";
import { IdCard, Cpu, ShieldCheck, Briefcase, GraduationCap, Handshake } from "lucide-react";

const products = [
    { icon: IdCard, name: "Simonara Talent Passport™", desc: "Your verified professional identity — built once, discovered everywhere.", span: "md:col-span-2" },
    { icon: Cpu, name: "Simonara Match™", desc: "AI candidate matching beyond keywords." },
    { icon: ShieldCheck, name: "Simonara Verify™", desc: "Verification signals that de-risk every hire." },
    { icon: Briefcase, name: "Simonara Hire™", desc: "The employer workspace for collaborative hiring.", span: "md:col-span-2" },
    { icon: GraduationCap, name: "Simonara Coach™", desc: "AI career coaching — resumes, interviews, salary negotiation." },
    { icon: Handshake, name: "Simonara Recruit™", desc: "Premium human recruiting for hard-to-fill roles." },
];

export const ProductFamily = () => (
    <section className="section-pad" data-testid="product-family-section">
        <div className="container-page">
            <div className="max-w-2xl">
                <p className="overline">The Simonara Platform</p>
                <h2 className="mt-3 font-heading font-semibold text-3xl sm:text-4xl tracking-tight text-foreground">
                    One product family. The whole hiring journey.
                </h2>
            </div>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
                {products.map((p, i) => (
                    <motion.div
                        key={p.name}
                        initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                        data-testid={`product-${p.name.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-+$/, "")}`}
                        className={`rounded-2xl border border-border bg-card p-8 h-full hover:border-emerald-500/40 hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 ${p.span || ""}`}
                    >
                        <div className="w-11 h-11 rounded-xl bg-accent text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
                            <p.icon size={20} />
                        </div>
                        <h3 className="mt-5 font-heading font-semibold text-lg text-foreground">{p.name}</h3>
                        <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default ProductFamily;
